import { Avatar } from '@mui/material';
import CandidateAvatar from 'components/ui/Icon/CandidateAvatar';
import CompanyAvatar from 'components/ui/Icon/CompanyAvatar';
import * as React from 'react';
import { checkValidUrl } from 'utils/collections';

const pxSize = {
    sm: 25,
    md: 72,
    lg: 125,
    semi: 40
};

export type AvatarWrapperProps = {
    size?: 'sm' | 'md' | 'lg' | 'semi';
    type?: 'company' | 'user';
    url?: string | null;
};

const AvatarWrapper = ({ size = 'md', type = 'user', url }: AvatarWrapperProps) => {
    const [imageExists, setImageExists] = React.useState<boolean>();

    React.useEffect(() => {
        if (url) {
            checkValidUrl(url).then((result) => {
                setImageExists(result);
            });
        }
        setImageExists(false);
    }, [url]);

    return (
        <>
            {!imageExists && type === 'user' && <CandidateAvatar size={size} />}
            {!imageExists && type === 'company' && <CompanyAvatar size={size} />}
            {imageExists && <Avatar sx={{ width: pxSize[size], height: pxSize[size] }} alt="avatar wrapper" src={url!!} />}
        </>
    );
};

export default AvatarWrapper;
